module.exports = __webpack_public_path__ + "static/media/nebel.02103ede.m4a";